import styled, { css } from 'styled-components';
import { H3Text, CaptionText } from '@prisjakt/ui/text/variants';
import { layout, media } from 'src/components/base';
import { Tooltip as TooltipComponent } from 'src/components/tooltip-new';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

export const Title = styled(H3Text)`
  white-space: nowrap;
  margin-right: ${layout.measurements.spacing050};
  margin-bottom: 0;
`;

export const Subtitle = styled(CaptionText)``;

export const HeaderRow = styled.div(
  () => css`
    display: flex;
    width: 100%;
    grid-column-gap: ${layout.measurements.spacing050};
    align-items: center;

    ${media.mediumDown`
      justify-content: space-between;
  `}
  `
);

export const DisplayOptions = styled.div`
  display: grid;
  grid-column-gap: ${layout.measurements.spacing050};
  align-items: center;
  grid-auto-flow: column;
`;

type SearchInputIconProps = {
  positionAbsolute?: boolean;
  iconSize: number;
};

export const SearchInputIcon = styled.button<SearchInputIconProps>`
  ${({ positionAbsolute }) =>
    positionAbsolute
      ? css`
          position: absolute;
          right: 0;
        `
      : ''}
  height: 100%;
  width: ${p => p.iconSize}px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${p => p.theme.icons.callToActionHover};
  }
`;

export const Tooltip = styled(TooltipComponent)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
